/**
 * 统计各个模块的待处理事项
 */
import { getWwwCount, getBillCount } from "@/service/count.js";
import { getOrderList } from "@/service/mall_handmade_order";
import { getPendingAfterSalesBucketCount } from "@/service/after-sales";
import { getMyIntentionCount } from "@/service/intention";
import { countInvoiceFinance } from "@/service/fms_invoice";
import { getOrderStat } from "@/service/mall_internal";
import { getSurveyStat } from "@/service/survey";
import store from "@/store";

export const useCount = () => {
    const countWww = async () => {
        const res = await getWwwCount();
        const data = res.data.data;

        store.commit("app/SET_COUNTS", {
            key: "fms-order",
            value: Object.values(data).reduce((a, b) => a + b, 0),
        });

        Object.keys(data).forEach((key) => {
            store.commit("app/SET_COUNTS", { key, value: data[key] });
        });
    };

    const countBill = async () => {
        const res = await getBillCount({ status: 0 });
        const data = res.data.data;
        store.commit("app/SET_COUNTS", {
            key: "finance-receipt",
            value: data,
        });

        store.commit("app/SET_COUNTS", {
            key: "finance-bill-statement",
            value: data,
        });
    };

    const countOrderConfirm = async () => {
        // 支付成功
        const res = await getOrderList({
            pay_status: 2,
        });
        const data = res.data.data?.total || 0;

        store.commit("app/SET_COUNTS", {
            key: "fms-order",
            value: data,
        });

        store.commit("app/SET_COUNTS", {
            key: "fms-order-business",
            value: data,
        });
    };

    const countPendingWorkflow = async () => {
        const res = await getPendingAfterSalesBucketCount();

        const statusMap = res.data?.data;
        store.commit("app/SET_COUNTS", {
            key: "workflowStatusMap",
            value: statusMap,
        });

        const data = statusMap?.[0] || 0;

        store.commit("app/SET_COUNTS", {
            key: "fms-after-sales",
            value: data,
        });

        store.commit("app/SET_COUNTS", {
            key: "fms-workflows-mine",
            value: data,
        });
    };

    const countMyIntentions = async () => {
        const res = await getMyIntentionCount({ status: "0,10,20" });

        const data = res.data.data || 0;
        store.commit("app/SET_COUNTS", {
            key: "fms-order",
            value: data,
        });
        store.commit("app/SET_COUNTS", {
            key: "fms-order-intention",
            value: data,
        });
    };

    const countFinance = async () => {
        const res = await countInvoiceFinance();
        const data = res.data.data || {};
        store.commit("app/SET_COUNTS", {
            key: "finance-invoice",
            value: data.invoice_request || 0,
        });
        store.commit("app/SET_COUNTS", {
            key: "finance-invoice-pending",
            value: data.invoice_request || 0,
        });
        store.commit("app/SET_COUNTS", {
            key: "finance-exception",
            value: data.exception_order || 0,
        });
        store.commit("app/SET_COUNTS", {
            key: "finance-bill-exception-order",
            value: data.exception_order || 0,
        });
    };

    const countInventory = async () => {
        const res = await getOrderStat();
        const data = res.data.data || [];
        const count = data.find((item) => item.status == 1)?.count || 0;
        store.commit("app/SET_COUNTS", {
            key: "prod-inventory",
            value: count,
        });
        store.commit("app/SET_COUNTS", {
            key: "prod-inventory-pending-orders",
            value: count,
        });
    };

    const countSurvey = async () => {
        const res = await getSurveyStat();
        const data = res.data.data || {};
        const count = data[1] || 0;
        store.commit("app/SET_COUNTS", {
            key: "cms-support",
            value: count,
        });
        store.commit("app/SET_COUNTS", {
            key: "cms-support-survey",
            value: count,
        });
    };

    return {
        countWww,
        countBill,
        countOrderConfirm,
        countPendingWorkflow,
        countMyIntentions,
        countFinance,
        countInventory,
        countSurvey,
    };
};
